import gettext from '@sdk/lang/gettext';
import { SmartTooltip } from 'sling-sdk/src/common/tooltip/SmartTooltip';

import MutedIcon from '@web/assets/svg/Icons/16/muted.svg';

export const MutedConversationBadge = () => {
  const tooltipText = gettext(
    'This conversation has been muted. Unmute it through the options menu.'
  );

  return (
    <SmartTooltip content={tooltipText} place="right" offset={{ top: 0 }}>
      <MutedIcon />
    </SmartTooltip>
  );
};
